<template>
  <div class="page">
    <van-nav-bar
      class="nav-bar"
      left-text="返回"
      left-arrow
      @click-left="back"
    />
    <iframe id="frame"  :src="$route.query.url"  onload="" ></iframe>
  </div>
</template>

<script>
export default {
  methods: {
    back() {
      this.$router.push({
        name: "main",
        query: {
          lat: this.$route.query.lat,
          lng: this.$route.query.lng,
          zoom: 14
        }
      })
    }
  }
}
</script>

<style scoped>
.page >>> .van-nav-bar__text,.main>>>.van-icon{
  color: #333333;
}
#frame {
  width: 100%;
  height: calc(100vh - 100px);
  border: 0;
  margin: 0;
} 
</style>